import { render } from "./interview-candidates.vue?vue&type=template&id=c8ff115e"
import script from "./interview-candidates.vue?vue&type=script&lang=js"
export * from "./interview-candidates.vue?vue&type=script&lang=js"
script.render = render

export default script